import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faDatabase, faSparkles } from "@fortawesome/pro-regular-svg-icons";

import { IcpPosition } from "../../enum/icp.enum";

export interface SearchEngineMeta {
	icon: IconDefinition;
	/** i18n key under `defineIcps.defineIcp` for the badge label. */
	labelKey: string;
	/** i18n key under `defineIcps.defineIcp` for the badge tooltip. */
	infoKey: string;
	/** Tailwind color tokens for the badge pill. */
	className: string;
}

const DATABASE_AND_AI: SearchEngineMeta = {
	icon: faSparkles,
	labelKey: "engineDatabaseAi",
	infoKey: "engineDatabaseAiInfo",
	className: "bg-blue-action-200 text-blue-action",
};

const DATABASE_ONLY: SearchEngineMeta = {
	icon: faDatabase,
	labelKey: "engineDatabase",
	infoKey: "engineDatabaseInfo",
	className: "bg-status-success-light text-status-success",
};

/** Which search engine each position option uses (mirrors the v8 "Find person" mockup badges). */
export const SEARCH_ENGINE_BY_POSITION: Record<IcpPosition, SearchEngineMeta> = {
	[IcpPosition.CEO_AND_SIMILAR]: DATABASE_AND_AI,
	[IcpPosition.PERSONA_SEGMENT]: DATABASE_AND_AI,
	[IcpPosition.CUSTOM]: DATABASE_AND_AI,
	[IcpPosition.DEPARTMENT_SENIORITY]: DATABASE_ONLY,
};
